export default "__VITE_ASSET__E_TEBUKN__$_?nuxt_component=async&nuxt_component_name=IconFunctionIconsTwinset&nuxt_component_export=default__"